import React, { useEffect, useMemo, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Collapse from 'react-bootstrap/Collapse';
import { API_BASE_URL } from '../config/api';
import { getoptionalAppAuthHeaders } from '../utils/optionalAppAuth';

function heartToggle() {
    var heartBlaste = document.querySelector('.heart');
    if (heartBlaste) {
        heartBlaste.classList.toggle("heart-blast");
    }
}

function Footer({ footerChange, logoImage }) {
    const d = new Date();
    const [accordBtn, setAccordBtn] = useState();
    const [categories, setCategories] = useState([]);
    const [categoriesLoading, setCategoriesLoading] = useState(true);
    const navigate = useNavigate()

    useEffect(() => {
        const loadCategories = async () => {
            setCategoriesLoading(true);
            try {
                const response = await fetch(`${API_BASE_URL}/server/website/categories`, { headers: { ...getoptionalAppAuthHeaders() } });
                const result = await response.json();
                if (response.ok && result?.success) {
                    const raw = result?.data?.categories || [];
                    const normalized = raw.map((item) => String(item?.name || item || '').trim()).filter(Boolean);
                    setCategories(normalized);
                }
            } catch {
                setCategories([]);
            } finally {
                setCategoriesLoading(false);
            }
        };
        loadCategories();
    }, []);

    const categoryColumnA = useMemo(() => categories.slice(0, 6), [categories]);

    const socialLinks = [
        { icon: "facebook-f", label: "Facebook", url: "https://www.facebook.com/people/Art-Tokri/61582149274629/" },
        { icon: "instagram", label: "Instagram", url: "https://www.instagram.com/art_tokri/" },
        { icon: "youtube", label: "YouTube", url: "https://www.youtube.com/channel/UClUyX-7tway1NF1c2BfIvcQ/" },
        { icon: "twitter", label: "Twitter", url: "https://x.com/Art_Tokri" },
        { icon: "linkedin", label: "LinkedIn", url: "https://www.linkedin.com/company/art-tokri-official/" },
        { icon: "pinterest", label: "Pinterest", url: "https://in.pinterest.com/art_tokri/" }
    ]

    return (
        <>
           
            <footer className={`site-footer ${footerChange}`} style={{
                background: 'linear-gradient(180deg, #fff7f2 0%, #fdeee4 100%)',
                color: '#5a3e36', paddingTop: "50px"
            }}>
                <div className="footer-top" style={{ padding: '20px 0 ' }}>
                    <div className="container">
                        <div className="row">

                            <div className="col-lg-4 mb-4">
                                <img src={logoImage} alt="Art Tokri Logo" style={{ height: '80px', marginBottom: '15px' }} />

                                <p style={{
                                    fontWeight: '600',
                                    fontSize: '20px',
                                    lineHeight: '1.6'
                                }}>
                                    Every product you buy helps a student grow, learn, and dream bigger.
                                </p>

                                <p style={{ color: '#7a5c50', marginTop: '10px' }}>
                                    Yahan se kharida har product ek student ke sapno ko support karta hai.
                                </p>

                                <p style={{ marginTop: '20px', fontWeight: '500' }}>Follow student journeys</p>

                                <div style={{ display: 'flex', gap: '10px' }}>
                                    {socialLinks.map((item, i) => (
                                        <a
                                            key={i}
                                            href={item.url}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="social-icon"
                                            aria-label={item.label}
                                        >
                                            <i className={`fa-brands fa-${item.icon}`}
                                                aria-hidden="true"
                                            ></i>
                                        </a>
                                    ))}
                                </div>
                            </div>

                            <div className="col-lg-2 col-md-6 mb-4">
                                <p className="footer-title">Our Links</p>
                                <ul className="footer-list">
                                    <li><Link to="/faq" className="footer-link"><span className="arrow">›</span>FAQ's</Link></li>
                                    <li><Link to="/all-testimonials" className="footer-link"><span className="arrow">›</span>Testimonials</Link></li>
                                    <li><Link to="/privacy-policy" className="footer-link"><span className="arrow">›</span>Privacy Policy</Link></li>
                                    <li><Link to="/terms-and-condition" className="footer-link"><span className="arrow">›</span>Terms & Conditions</Link></li>
                                    <li><Link to="/shipping-and-delivery" className="footer-link"><span className="arrow">›</span>Shipping Policy</Link></li>
                                    <li><Link to="/refund-concellation" className="footer-link"><span className="arrow">›</span>Refund Policy</Link></li>
                                    <li><Link to="/all-blogs" className="footer-link"><span className="arrow">›</span>Blogs</Link></li>
                                </ul>
                            </div>

                            <div className="col-lg-3 col-md-6 mb-4">
                                <p className="footer-title">Student Creations</p>
                                <ul className="footer-list">
                                    {categoryColumnA.map((name, i) => (
                                        <li key={i}>
                                            <Link to={`/shop?category=${name}`} className="footer-link">
                                                <span className="arrow">›</span>{name}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>

                                <button
                                    // onClick={() => navigate('/student_panel/register')}
                                    style={{
                                        marginTop: '10px',
                                        // background: 'linear-gradient(90deg,#ff7a2f,#ff9a4d)',
                                        border: 'none',
                                        // padding: '10px 18px',
                                        // borderRadius: '25px',
                                        // color: '#fff',
                                        // fontWeight: '500'
                                    }}
                                >
                                    <a href='https://arttokri.com/student_panel/register'
                                        target='_blank'
                                        aria-label="Join as Student"
                                        style={{
                                            marginTop: '10px',
                                            background: 'linear-gradient(90deg,#ff7a2f,#ff9a4d)',
                                            border: 'none',
                                            padding: '10px 18px',
                                            borderRadius: '25px',
                                            color: '#fff',
                                            fontWeight: '500'
                                        }}
                                    >
                                        Join As Student
                                    </a>
                                </button>
                            </div>

                            <div className="col-lg-3">
                                <p className="footer-title">Have questions?</p>
                                <p style={{ fontWeight: '500' }}>We’re here to help.</p>

                                <div className="">
                                    <i className="fa-solid fa-location-dot" style={{ color: "#ff7a2f", padding: "0 5px" }}></i>
                                    <span style={{ margin: "0 5px" }}>Office No 202, 2nd floor, Gracia Heights, Devi Ahilya Marg, above HDFC Bank, Snehlataganj, Indore, Madhya Pradesh 452003</span>
                                </div>

                                {/* <div className="contact-item mb-0">
                                    <i className="fa-solid fa-phone"></i>
                                    <span>+91 9009081085</span>
                                </div> */}
                                <div className="contact-item mb-3 mt-2">
                                    <i className="fa-solid fa-phone"></i>
                                    <span>+91 9009958137</span>
                                </div>

                                <div className="contact-item">
                                    <i className="fa-solid fa-envelope"></i>
                                    <span>support@arttokri.com</span>
                                </div>
                            </div>

                        </div>

                        <div className="badge-wrapper">
                            <div className="badge-item">
                                <i className="fa-solid fa-user me-2"></i>
                                <span>Verified Student Creators</span>
                            </div>

                            <div className="badge-item">
                                <i className="fa-solid fa-shield me-2"></i>
                                <span>Secure Payments via Razorpay</span>
                            </div>

                            <div className="badge-item">
                                <i className="fa-solid fa-award me-2"></i>
                                <span>Quality Checked Products</span>
                            </div>
                        </div>

                        <p style={{
                            textAlign: 'center',
                            color: '#7a5c50',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '6px'
                        }}>
                            Built with
                            <i className="fa-solid fa-heart footer-heart text-danger"></i>
                            to empower student creators.
                        </p>
                    </div>
                </div>

                <div className="footer-bottom" style={{ padding: "15px" }}>
                    <div className="container">
                        <div className="row" style={{ alignItems: 'center' }}>
                            <div className="col-lg-6 text-start">
                                <p style={{ margin: 0, fontSize: '13px', color: "#000" }}>
                                    Art Tokri - © {d.getFullYear()} All Rights Reserved
                                </p>
                            </div>
                            <div className="col-lg-6 text-end">
                                <p style={{ margin: 0, fontSize: '13px', color: "#000" }}>
                                    Made with <i className="fa-solid fa-heart footer-heart text-danger"></i>  by
                                    <a href="https://youngdecade.com/" target="_blank" rel="noreferrer" style={{ marginLeft: '5px', color: '#ff7a2f' }}>
                                        Young Decade IT Software Solution LLP
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

            <style>{`
.footer-title{font-size:18px;font-weight:600;margin-bottom:15px}
.footer-list{list-style:none;padding:0}
.footer-list li{margin-bottom:10px}

.footer-link{display:flex;align-items:center;gap:8px;color:#7a5c50;text-decoration:none;transition:.3s}
.footer-link .arrow{color:#ff7a2f;font-size:18px}
.footer-link:hover{color:#ff7a2f;transform:translateX(5px)}

.social-icon{
width:40px;height:40px;border-radius:50%;
display:flex;align-items:center;justify-content:center;
background:linear-gradient(135deg,#fff,#ffe9dc);
border:1px solid #f5d3c5;
color:#ff7a2f;
transition:.3s
}
.social-icon:hover{
transform:translateY(-5px);
background:linear-gradient(135deg,#ff7a2f,#ff9a4d);
color:#fff
}

.contact-item{display:flex;align-items:center;gap:10px;margin-bottom:10px}
.contact-item i{color:#ff7a2f}

.badge-wrapper{
// margin-top:30px;
padding:15px;
border-radius:30px;
background:#fff3ea;
display:flex;
flex-wrap:wrap;
gap:15px;
justify-content:center
}

.badge-item{
background:#fff;
padding:8px 15px;
border-radius:20px;
font-size:13px;
box-shadow:0 2px 6px rgba(0,0,0,0.05)
}

.footer-bottom{
background:#fde6d8;
padding:0px 0
}

@media(max-width:768px){
.footer-top{padding:40px 0 !important}
.text-end{text-align:center !important;margin-top:10px}
.text-start{text-align:center !important}
}
`}</style>
        </>
    )
}

export default Footer;
